import styles from "./header.module.css";
import pic from "../../assets/images/profile.jpg";
const Header = () => {
  const aboutText = `<p>Hey, my name is Sajad and I'm a <strong>Computer Science Student </strong>and interested in everything related to technology and computers. Over the years I have done a lot of work in the field of web development such as Back-End and Front-end development and I am familiar with the various programming languages ​​used in this field and I am fluent in some of them. As I said, I am currently a student of computer science and I am studying and I am getting acquainted with different dimensions of the world of computer science. Until last year (2020) I decided to continue my work in the field of the web, but for a year now I have decided to work in the field of <strong>#Software Engineering</strong> and <strong>#Artificial Intelligence</strong>, and <strong>#Machine Learning</strong> and have more connections with <strong>#Data</strong>. I am very interested in the fields of <strong>#Deep Learning</strong> and <strong>#Computer Vision</strong> and <strong>#Natural Language Processing</strong>, and I am trying to be serious in these fields and work in the field of software development in these fields. In order to develop software and algorithms related to these fields.</p>`;
  return (
    <div className={`${styles.header} flex-column md:flex-row md:flex`} id="summary">
      <div className={`${styles.left} w-full md:w-2/6 lg:w-2/6 xl:w-1/4`}>
        <div className={styles.picture}>
          <img src={pic} alt="Sajad Kolahchi" layout="responsive" />
        </div>
        <div className={styles.name}>
          <span>Sajad</span>
          <span>Kolahchi</span>
        </div>
        <div className={styles.role}>
          <span>Software Developer</span>
        </div>
      </div>
      <div className={`${styles.right} w-full pt-5  md:w-4/6 md:pt-0 lg:w-4/6 xl:w-3/4`}>
        <div
          className={styles.about}
          dangerouslySetInnerHTML={{ __html: aboutText }}
        ></div>
        <div className={`${styles.contact} flex-col md:flex-row`}>
          <div className={`${styles.contactitem} w-full md:w-max`}>
            <i className="fal fa-map-marker-alt"></i>
            <span>Tehran , Iran</span>
          </div>
          <div className={`${styles.contactitem} w-full md:w-max`}>
            <i className="fal fa-paper-plane"></i>
            <span>SajadKolahchi@gmail.com</span>
          </div>
        </div>
        <div className={`${styles.dl} w-full`}>
          <i className="far fa-cloud-download"></i>
          <span>Download My Resume</span>
        </div>
        <div className={`${styles.social} w-full text-center mb-0 mt-8`}>
          <a href="https://github.com/sajadko">
            <li>
              <i className="fab fa-github"></i>
              <span>Github Profile</span>
            </li>
          </a>
          <a href="https://www.linkedin.com/in/sajadkolahchi/">
            <li>
              <i className="fab fa-linkedin-in"></i>
              <span>Linkedin</span>
            </li>
          </a>
          <a href="https://huggingface.co/sajadk">
            <li>
              <i className="fal fa-smile-beam"></i>
              <span>HuggingFace Profile</span>
            </li>
          </a>
          <a href="#1">
            <li>
              <i className="fal fa-user-graduate"></i>
              <span>Google Scholar</span>
            </li>
          </a>
          <a href="#1">
            <li>
              <i className="fab fa-twitter"></i>
              <span>#Twitter</span>
            </li>
          </a>
          <a href="mailto:sajadkolahchi@gmail.com">
            <li>
              <i className="fal fa-at"></i>
              <span>Email Me !</span>
            </li>
          </a>
          <a href="#1">
            <li>
              <i className="fab fa-instagram"></i>
              <span>My Instagram</span>
            </li>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
